// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
/**
 * Native contactprovider - PLAATSHOUDER VOOR FASE 2.
 *
 * In de huidige web-build is deze bron niet beschikbaar (`isSupported()` → false),
 * zodat er niets verandert aan het webgedrag.
 *
 * Wanneer WilsApp later als native app draait (bijv. via Capacitor), hoeft ALLEEN dit
 * bestand te worden aangesloten:
 *   - isSupported(): detecteer de native runtime (bijv. Capacitor.isNativePlatform()).
 *   - pick(): roep de Capacitor Contacts-plugin aan, die intern
 *       iOS:     CNContactStore (Contacts Framework)
 *       Android: Contacts Provider
 *     gebruikt, en map het resultaat naar ProvidedContact[].
 *
 * De rest van de applicatie (UI, hook, registry) blijft ongewijzigd, omdat alles via
 * de ContactProvider-interface loopt.
 */
import type { ContactProvider, ProvidedContact } from '../types'

export const nativeContactProvider: ContactProvider = {
  // Wordt in Fase 2 runtime bepaald (native-ios / native-android).
  id: 'native-android',
  label: 'Telefooncontacten',
  description: 'Kies uit de contacten op uw telefoon.',
  capabilities: { multiSelect: true, exposesFullList: true, inAppSearch: true },

  isSupported() {
    // Web-build: altijd false. Fase 2: vervang door native-runtime-detectie.
    return false
  },

  async pick(): Promise<ProvidedContact[]> {
    throw new Error('Native contactprovider is in deze build niet beschikbaar (Fase 2).')
  },
}
